import React from 'react';
import { format } from 'date-fns';

const LeadRow = (props) => {
    const {lead} = props;
    return(
        <tr>
            <td>
                <input type="checkbox" name="select-1" checked={lead.isChecked} onChange={()=>{props.handleCheckboxChange(lead._id)}} />
            </td>
            <td>{lead.email}</td>
            <td>{lead.campaign_name}</td>
            <td>{lead.assigned_to_name ? lead.assigned_to_name : 'Unassigned'}</td>
            <td>{format(lead.created_at,'MM/dd/yyyy')}</td>
        </tr>
    );
}

export default LeadRow;